import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=b041b1a2&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b041b1a2')) {
      api.createRecord('b041b1a2', component.options)
    } else {
      api.reload('b041b1a2', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=b041b1a2&", function () {
      api.rerender('b041b1a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QJr7G3fb1Rv2/JS/comp/openstreetmap.vue"
export default component.exports